var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-tip"},[(_vm.title)?_c('span',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }